import { ApolloError, DocumentNode, OperationVariables } from '@apollo/client'
import * as React from 'react'

import { useApolloDefenderCtx } from '../ApolloDefender'
import { ApolloOperationError } from '../helpers/ApolloOperationError'

/**
 * Used to add custom error handling to the operation hooks (useQuery, useLazyQuery, useSubscription),
 * that way operation errors are handled automatically, without a need to handle them one by one on every use
 */
export const useApolloDefenderReporter = (
  error: ApolloError | undefined,
  query: DocumentNode,
  variables?: OperationVariables,
) => {
  const { onError } = useApolloDefenderCtx()

  React.useEffect(() => {
    if (!error) return

    onError(new ApolloOperationError(error, query, variables))
  }, [onError, error, query, variables])

  return null
}
